import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import config from "../../config"
import { useNetworkState } from 'react-use';
import Footer from './Footer';
import Header from './Header';


const Add_channel = () => {
    const isOnline = useNetworkState();
    console.log("isONline  === " ,isOnline )
    const[state,setState] = React.useState([])
   
    React.useEffect(()=>{
        getChannelList()
    },[])
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
    const getChannelList = () => {


        let url = config.apiUrl + '/user/channel_find';
        let sendData = {};
        // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            // console.log("res ", res);  
            if(res.data.status==true){         
            setState(res.data.output)
            }
            else{
                Toast.fire({
                    background:"#a61c09",
                    type: 'unsuccess',
                    title: "Something Went Wrong",
                    color:"white"
                  });
            }
    
        }).catch((e) => {
            Toast.fire({
                background:"#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color:"white"
              });
    
        });
    }
  return (
    <div>
        <Header/>
 <div class="page-wrapper pinned">
  <div class="main-container">
   <div className='app-container'>
  <div class="app-body">
  <div class="container-fluid"> 
  <section class="mb-3  tools">
        <div class="">
            <div class="row ">
                <div class="col-12 col-md">
                <div class="d-flex">
                <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                    <h2>Connect a Channel</h2>
                </div>
                </div>
                <div class="col-12 col-md-4 text-end">
                   
                </div>
            </div>
            <div class="row chanel_list">
                {state.length>0?
                state.map((sub)=>(
                <div class="col-12 col-md-4 mb-3">
                        <div class="card  shadow-sm ">
                            <div class="card-body">
                                <div class="text-center">
                                    <figure>
                                        <img src={`https://cdn.dartonexpress.in/channel_images/${sub.channel_img}`} class="img-fluid" style={{height:"100px"}}/>
                                    </figure>
                                    <h4>{sub.channel_name}</h4>
                                </div>

                            <hr/>
                            <div class="text-center">
                                    <a href={`/channel_integrate/${sub.channel_id}`} class="btn btn-primary btn-sm">Integrate</a>
                            </div>
                        </div>
                    </div>
                </div>
       )) :""}   
            </div>
        </div>  
        </section>
    </div>
    </div>
    <Footer/>
    </div>
    </div>
    </div>
    </div>
  )
}

export default Add_channel
